import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { Icon, Stack } from '@fluentui/react';

import { PropertyAttributeTypeEnum } from '../../../../../api-client';
import { DataEnchanter } from '../../../../../utils/data-enchanters';

interface IAttributeTypeColumn {
    align: 'start' | 'center' | 'end';
    type?: PropertyAttributeTypeEnum;
}

const IAIStatusColumn: React.FunctionComponent<IAttributeTypeColumn> = ({
    align = 'start',
    type = PropertyAttributeTypeEnum.Combo
}) => {
    const {
        t: translate
    } = useTranslation();

    return (
        <div className={`text-${align}`}>
            <Stack horizontal verticalAlign="center" verticalFill tokens={{ childrenGap: 5 }}>
                <Icon
                    iconName={type === PropertyAttributeTypeEnum.Combo
                        ? "GroupList"
                        : type === PropertyAttributeTypeEnum.Input
                            ? "TextField"
                            : "EventDate"
                    }
                    styles={{ root: { fontSize: 16 } }}
                />
                <span>
                    {translate(DataEnchanter.textByAttributeTypeEnum(type))}
                </span>
            </Stack>
        </div>
    );
}

export default IAIStatusColumn;